import { PROGRAM_KEYS } from 'components/global/Constant/constants';

export type ApplicationDetailsProgramKind = 'csp' | 'capitalAccess' | 'other';

export type ApplicationDetailsLike = {
  fundingProgram?: { referenceProgram?: { key?: string | null } } | null;
  fundingProgramMembership?: { fundingProgram?: { referenceProgram?: { key?: string | null } } | null } | null;
};

export function getFundingProgramFromApplicationDetails(
  details: ApplicationDetailsLike | null | undefined
): { referenceProgram?: { key?: string | null } } | null | undefined {
  if (!details) return undefined;
  return details.fundingProgram ?? details.fundingProgramMembership?.fundingProgram ?? undefined;
}

export function resolveApplicationDetailsProgramKind(
  details: ApplicationDetailsLike | null | undefined
): ApplicationDetailsProgramKind {
  const key = getFundingProgramFromApplicationDetails(details)?.referenceProgram?.key;
  if (key === PROGRAM_KEYS.collateralSupport) return 'csp';
  if (key === PROGRAM_KEYS.capitalAccess) return 'capitalAccess';
  return 'other';
}

export function applicationDetailsProgramKindLabel(kind: ApplicationDetailsProgramKind): string {
  switch (kind) {
    case 'csp':
      return 'Collateral Support Program (CSP)';
    case 'capitalAccess':
      return 'CalCAP / Capital Access';
    case 'other':
      return 'Other program';
    default:
      return 'Program';
  }
}
